export const OWNERSHIP_CAP_EXCEEDED_MESSAGE = "Total ownership percentage cannot exceed 100%";

type OwnerPercentage = { percentOwnership?: number | null } | null | undefined;

type ParentRelationship = {
  parentProfileId?: number | null;
  percentOwnership?: number | null;
} | null;

type CaseOwnershipData = {
  investingProfile?: {
    id?: number | null;
    beneficialOwners?: OwnerPercentage[] | null;
  } | null;
  profiles?: Array<{
    parentRelationships?: ParentRelationship[] | null;
  } | null> | null;
} | null;

export const sumOwnerPercentages = (owners: OwnerPercentage[] | null | undefined): number =>
  (owners ?? []).reduce((total, owner) => total + (owner?.percentOwnership ?? 0), 0);

export const getExistingOwnershipTotal = (
  complianceCase: CaseOwnershipData,
  parentProfileId: number,
): number => {
  const siblingRelationships = (complianceCase?.profiles ?? [])
    .flatMap((profile) => profile?.parentRelationships ?? [])
    .filter((rel) => rel?.parentProfileId === parentProfileId);

  if (siblingRelationships.length > 0) {
    return sumOwnerPercentages(siblingRelationships);
  }

  if (complianceCase?.investingProfile?.id === parentProfileId) {
    return sumOwnerPercentages(complianceCase.investingProfile.beneficialOwners);
  }

  return 0;
};

export const wouldExceedOwnershipCap = (
  existingTotal: number,
  additionalPercentage: number | null | undefined,
): boolean => existingTotal + (additionalPercentage ?? 0) > 100;
